import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { authApi } from '../../api/auth';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import AuthShell from './AuthShell';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await authApi.requestPasswordReset(email);
    } catch {
      // The backend always 204s here; ignore any transport hiccups so we
      // don't leak whether the address exists.
    }
    setDone(true);
    setSubmitting(false);
  };

  return (
    <AuthShell
      title={done ? 'Check your email' : 'Forgot password'}
      subtitle={
        done
          ? 'If an Atharva account uses that email, we just sent a reset link. The link is valid for three days.'
          : "Enter the email on your Atharva account. We'll send a reset link if it matches."
      }
      footer={
        <>
          Remembered it?{' '}
          <Link to="/login" className="font-medium text-green-700 hover:text-green-800">
            Back to sign in
          </Link>
        </>
      }
    >
      {!done && (
        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
          <Input
            type="email"
            label="Email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Button type="submit" disabled={submitting}>
            {submitting ? 'Sending…' : 'Send reset link'}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
